import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  container: {
    zIndex: theme.zIndex.one,
  },
});

export default withStyles(styles);
